import React from 'react';

import LoadingSpinner from 'components/LoadingSpinner';

import { classNames } from 'utils/functions';
import { BUTTON_COLORS } from 'utils/enums';

const colorClasses = {
  primary: 'border-primary-900 text-primary-900 hover:bg-primary-900 hover:text-white',
  blue: 'border-blue-900 text-blue-900 hover:bg-blue-900 hover:text-white',
  red: 'border-red-900 text-red-900 hover:bg-red-900 hover:text-white',
};

export default function OutlineButton({
  color = BUTTON_COLORS.PRIMARY,
  className = '',
  onClick,
  isLoading,
  children,
}: {
  color?: BUTTON_COLORS;
  className?: string;
  onClick?: () => void;
  isLoading?: boolean;
  children?: React.ReactNode;
}) {
  return (
    <button
      onClick={onClick}
      className={classNames(
        className,
        colorClasses[color],
        'rounded-lg border-2 px-4 py-2 font-bold transition-colors duration-300 sm:text-sm'
      )}
    >
      {isLoading ? <LoadingSpinner /> : children}
    </button>
  );
}
